import { useRef } from 'react';
import styled from 'styled-components';
import {
  mqXXLargeMin,
  mqSmallMin,
  mqSmallMax,
  mqTabletMax,
} from 'styled/tools/media-queries';
import { defaultFont } from 'styles/commonCss';
import { motion } from 'motion/react';
import SeedLogo from 'components/global/Logo';
import { usePinnedLogo } from 'components/pages/practitioners/animations';

const VideoStyled = styled.video`
  max-width: 100%;
  max-height: 100%;
  min-width: 100%;
  min-height: 100%;
  object-fit: var(--media-object-fit, contain);
  object-position: var(--media-object-position, 50% 50%);
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 35px;
  position: relative;
  width: 100%;
`;

const VideoWrapperMobile = styled.div`
  @media ${mqSmallMin} {
    display: none;
  }
`;

const VideoWrapperDesktop = styled.div`
  @media ${mqSmallMax} {
    display: none;
  }
`;

const LogoWrapper = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  padding-left: 0px !important;
  margin-top: 20px;

  @media ${mqSmallMax} {
    padding-left: 24px !important;
  }

  &.logo-wrapper-desktop {
    @media ${mqSmallMax} {
      display: none;
    }
  }

  &.logo-wrapper-mobile {
    @media ${mqSmallMin} {
      display: none;
    }
  }
`;

const HeroText = styled.h1`
  ${defaultFont};
  color: var(--text-inverse-primary);
  font-weight: 350;
  font-size: 52px;
  line-height: 100%;
  letter-spacing: -0.52px;
  padding: 0 48px 48px 48px;
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 1;

  @media ${mqSmallMin} {
    font-size: 7vw;
    line-height: 90%;
    letter-spacing: -2.16px;
  }

  @media ${mqTabletMax} {
    padding: 0 24px 24px 24px;
  }

  @media ${mqXXLargeMin} {
    font-size: 108px;
  }
`;

const PatientCareHero = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  const desktopLogoRef = useRef<HTMLDivElement>(null);
  const logoY = usePinnedLogo(desktopLogoRef, contentRef);

  return (
    <section>
      <Content className='patient-content' ref={contentRef}>
        <VideoWrapperMobile>
          <VideoStyled playsInline webkit-playsinline autoPlay loop muted>
            <source
              src={`https://res.cloudinary.com/dljz0lko8/video/upload/v1748378191/practitioners/HCP_homepage_mobile.mp4`}
              type='video/mp4'
            />
          </VideoStyled>
        </VideoWrapperMobile>
        <VideoWrapperDesktop>
          <VideoStyled playsInline webkit-playsinline autoPlay loop muted>
            <source
              src={`https://res.cloudinary.com/dljz0lko8/video/upload/v1748378192/practitioners/HCP_homepage.mp4`}
              type='video/mp4'
            />
          </VideoStyled>
        </VideoWrapperDesktop>
        <LogoWrapper
          className='logo-wrapper-desktop'
          ref={desktopLogoRef}
          style={{ y: logoY }}
        >
          <SeedLogo
            light
            size='natural'
            fontSize='16px'
            onClick={() => {}}
            $variant='practitioners'
          />
        </LogoWrapper>
        <LogoWrapper className='logo-wrapper-mobile'>
          <SeedLogo
            light
            fontSize='16px'
            onClick={() => {}}
            $variant='practitioners'
          />
        </LogoWrapper>
        <HeroText>Our Microbiome Innovations Transform Patient Care</HeroText>
      </Content>
    </section>
  );
};

export default PatientCareHero;
